import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import RecycleBinTable from "./RecycleBinTable";

class ProviderRecycleBinModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedIds: [],
            restoring: false,
        };
    }

    openModal = () => {
        this.setState({ selectedIds: [] }, () => {
            if (this.tableRef?.openModal) {
                this.tableRef.openModal();
            }
        });
    }

    handleSelectionChange = (selectedIds) => {
        this.setState({ selectedIds });
    }

    handleRestore = async () => {
        if (this.state.selectedIds.length === 0 || this.state.restoring) {
            return;
        }

        this.setState({ restoring: true });
        try {
            const response = await axios.post('/api/document_dossier/documents/restore', {
                ids: this.state.selectedIds,
            });

            const restoredIds = response.data?.ids || [];
            const restoredCount = restoredIds.length;

            this.setState({ selectedIds: [] }, async () => {
                if (this.tableRef?.fetchRows) {
                    await this.tableRef.fetchRows();
                }

                swal.fire({
                    text: restoredCount > 0
                        ? `Se restauraron ${restoredCount} documento(s).`
                        : 'No se restauró ningún documento.',
                    icon: restoredCount > 0 ? 'success' : 'info',
                    buttonsStyling: false,
                    confirmButtonText: 'Aceptar',
                    customClass: {
                        confirmButton: 'btn font-weight-bold btn-primary'
                    }
                }).then(() => {
                    if (this.tableRef?.closeModal) {
                        this.tableRef.closeModal();
                    }

                    if (this.props.onRestored) {
                        this.props.onRestored(restoredIds);
                    }
                });
            });
        } catch (error) {
            const message = error?.response?.data?.message || 'No se pudieron restaurar los documentos seleccionados.';
            swal.fire({
                text: message,
                icon: 'error',
                buttonsStyling: false,
                confirmButtonText: 'Aceptar',
                customClass: {
                    confirmButton: 'btn font-weight-bold btn-primary'
                }
            });
        } finally {
            this.setState({ restoring: false });
        }
    }

    render() {
        return (
            <RecycleBinTable
                ref={(ref) => { this.tableRef = ref; }}
                modalId={`providerRecycleBinModal${this.props.person_provider_id || this.props.personProviderId}`}
                person_provider_id={this.props.person_provider_id || this.props.personProviderId}
                title="Tipos de documento X"
                selectable={true}
                selectedIds={this.state.selectedIds}
                onSelectionChange={this.handleSelectionChange}
                footerActions={
                    <button
                        type="button"
                        className="btn btn-success font-weight-bolder px-10"
                        onClick={this.handleRestore}
                        disabled={this.state.selectedIds.length === 0 || this.state.restoring}
                    >
                        {this.state.restoring ? 'Restaurando...' : 'Restaurar documento'}
                    </button>
                }
            />
        );
    }
}

export default ProviderRecycleBinModal;

if (document.getElementById('ProviderRecycleBinModal')) {
    ReactDOM.render(<ProviderRecycleBinModal />, document.getElementById('ProviderRecycleBinModal'));
}
